import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TITLES = [
    ['/dashboard', 'Home'],
    ['/courses', 'Courses'],
    ['/lessons', 'Lesson'],
    ['/connect', 'Connect'],
    ['/progress', 'My Progress'],
    ['/manage', 'Manage Group'],
    ['/settings', 'Settings'],
    ['/privacy', 'Privacy Policy'],
    ['/terms', 'Terms of Service'],
    ['/contact', 'Contact'],
    ['/forgot-password', 'Reset Password'],
    ['/register', 'Sign Up'],
    ['/login', 'Log In'],
];

export const setPageTitle = (title) => {
    document.title = title ? `${title} · The Room` : 'The Room | Where small groups learn together';
};

export const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
        const match = TITLES.find(([prefix]) => pathname.startsWith(prefix));
        setPageTitle(match ? match[1] : null);
    }, [pathname]);
    return null;
};

export default ScrollToTop;
